"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNoManifest = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const faLayerGroup_1 = require("@fortawesome/free-solid-svg-icons/faLayerGroup");
const site_1 = require("@yanzi/site");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const GenericError_1 = require("../GenericError");
function ErrorNoManifest() {
    const { id } = site_1.useSite();
    const settingsUrl = react_1.useMemo(() => {
        if (id.type === 'location') {
            return `/locations/${id.locationId}/settings/floors`;
        }
        else if (id.type === 'prospect') {
            return `/prospects/${id.accountNumber}/${id.prospectId}/settings/floors`;
        }
        else {
            throw new Error('Invalid site ID');
        }
    }, [id]);
    return (jsx_runtime_1.jsxs(GenericError_1.GenericError, Object.assign({ title: "Let's set up some floors!", icon: faLayerGroup_1.faLayerGroup }, { children: [jsx_runtime_1.jsx("p", { children: "It seems like there are no floors set up for this location yet." }, void 0),
            jsx_runtime_1.jsx("p", { children: "To get the most out of Yanzi Live, please add your floor plans by following the link below." }, void 0),
            jsx_runtime_1.jsx(react_router_dom_1.Link, Object.assign({ to: settingsUrl }, { children: "Set up floors" }), void 0)] }), void 0));
}
exports.ErrorNoManifest = ErrorNoManifest;
//# sourceMappingURL=index.js.map